import { ListItemIcon, ListItemText, MenuItem } from "@mui/material";
import React from "react";
import EditIcon from "@mui/icons-material/Edit";

export default function ToggleEditPromptMenuItem({
  promptingMode,
  setPromptingMode,
  handleClose,
}) {
  return (
    <MenuItem
      onClick={() => {
        setPromptingMode(!promptingMode);
        handleClose();
      }}
    >
      <ListItemIcon>
        <EditIcon />
      </ListItemIcon>
      <ListItemText>{promptingMode ? "Edit Text" : "Edit Prompt"}</ListItemText>
    </MenuItem>
  );
}
